var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "item-container" }, [
    _vm.isFinalNode() && _vm.isNotFiltered()
      ? _c(
          "div",
          {
            staticClass: "item",
            class: { selected: _vm.isSelected, disabled: _vm.item.disabled },
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.toggleSelect(_vm.item)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "item-inner d-flex align-items-center gap-3",
                style: { "padding-left": 20 * _vm.level + "px" },
              },
              [
                _vm.itemType === "nom"
                  ? _c("SelectListItemNom", {
                      staticClass: "flex-grow-1",
                      attrs: { item: _vm.item },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.itemType === "dati"
                  ? _c("SelectListItemDati", {
                      staticClass: "flex-grow-1",
                      attrs: { item: _vm.item },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.itemType === "datiMonitoring"
                  ? _c("SelectListItemDatiMonitoring", {
                      staticClass: "flex-grow-1",
                      attrs: { item: _vm.item },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.warning
                  ? _c("i", {
                      staticClass: "fa fa-exclamation-triangle text-warning",
                      attrs: { title: _vm.warningTooltip },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "p-1 pl-2" },
                  [
                    _c("b-form-checkbox", {
                      staticStyle: { "pointer-events": "none" },
                      attrs: {
                        checked: _vm.item.selected,
                        disabled: _vm.item.disabled,
                        size: "lg",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isFinalNode() && _vm.isNotFiltered()
      ? _c(
          "div",
          {
            staticClass: "folder",
            class: [
              {
                show: _vm.opened,
                disabled:
                  _vm.childrenLock || _vm.noChildren || _vm.groupLockedForUser,
              },
              _vm.stateSelected,
            ],
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.toggleOpenGroup()
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "item-inner d-flex align-items-center",
                style: { "padding-left": 30 * _vm.level + "px" },
              },
              [
                _c("i", { staticClass: "handler fa fa-caret-right fa-lg" }),
                _vm._v(" "),
                _c("span", { staticClass: "flex-grow-1 text-lg" }, [
                  _vm._v(_vm._s(_vm.item.name)),
                ]),
                _vm._v(" "),
                _vm.childrenWarning || _vm.groupLockedForUser
                  ? _c("i", {
                      staticClass:
                        "fa fa-exclamation-triangle text-warning mr-2",
                      attrs: {
                        title: _vm.groupLockedForUser
                          ? _vm.warningGroupLockedForUser
                          : _vm.warningTooltipGroup,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "text-gray-400 mr-2 text-sm text-mono text-right",
                    staticStyle: { "font-weight": "400", "min-width": "5ch" },
                  },
                  [_vm._v(_vm._s(_vm.countSelected))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "p-1 pl-2",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.toggleSelectGroup()
                      },
                    },
                  },
                  [
                    _vm.groupLockedForUser
                      ? _c("i", { staticClass: "fa fa-lock fa-lg mr-3" })
                      : _c("b-form-checkbox", {
                          staticStyle: { "pointer-events": "none" },
                          attrs: {
                            size: "lg",
                            checked: _vm.stateSelected === "selected",
                            indeterminate:
                              _vm.stateSelected === "selected-partial",
                            disabled: _vm.childrenLock,
                          },
                        }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "wrapper",
                style: {
                  height: _vm.childrenHeight + "px",
                  transform: "scaleY(1)",
                },
              },
              _vm._l(_vm.itemChildren, function (itemChild) {
                return itemChild
                  ? _c("SelectListItemRenderer", {
                      key: itemChild.id,
                      attrs: {
                        item: itemChild,
                        itemType: _vm.itemType,
                        messages: _vm.messages,
                        level: _vm.level + 1,
                      },
                      on: { select: _vm.onSelect, unselect: _vm.onUnselect },
                    })
                  : _vm._e()
              }),
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }